module.exports = __webpack_public_path__ + "static/fonts/NanumGothic_seR.8c7fa4d.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/NanumGothic_seR.eot
// module id = l0WO
// module chunks = 241